import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_MSF_78 } from "@/lib/programs/marrakechSidialiFez78";

export default function MarrakechSidialiFez78Page() {
  return <ProgramTemplate program={PROGRAM_MSF_78} variant="msf" showJourneyChronology />;
}
